import {checkIfUnfinishedLocalMatch} from '../matches/tutorialMatchVisibility';

/**
 * Что показать о локальном матче в истории матчей (плашка и детали матча).
 *
 * Запись локальной партии создается на ее старте (есть статус и раунд). У
 * старых матчей статуса нет — они считаются завершенными; партия, сохраненная
 * только по итогам, получает сразу completed (см. LOCAL_MATCH_STATUSES).
 * Незавершенные видны в истории всем.
 *
 * @returns {null|{
 *   isRecordedFromStart: boolean,
 *   isUnfinished: boolean,
 *   historyDate: string|null,
 *   durationMs: number|null,
 *   lastRecordedRound: number|null,
 *   finalRound: number|null,
 * }}
 */
export const getLocalMatchInfo = (match) => {
  if (!match?.isLocal) {
    return null;
  }
  // Номер записанного раунда ставит только старт записи (на старте он 0);
  // статус для этого не годится: его получает и партия, сохраненная только
  // по итогам
  const isRecordedFromStart = match.lastRecordedRound !== null && match.lastRecordedRound !== undefined;
  const isUnfinished = checkIfUnfinishedLocalMatch(match);
  const lastRecordedRound = Number.isInteger(match.lastRecordedRound) && match.lastRecordedRound > 0
    ? match.lastRecordedRound
    : null;

  let durationMs = null;
  if (isUnfinished && match.startedAt) {
    // Партия брошена: «длительность» — от старта до последней записанной пачки
    const lastActivityAt = match.lastActivityAt ? new Date(match.lastActivityAt).getTime() : NaN;
    const startedAt = new Date(match.startedAt).getTime();
    durationMs = Number.isFinite(lastActivityAt) && Number.isFinite(startedAt)
      ? Math.max(0, lastActivityAt - startedAt)
      : null;
  } else {
    durationMs = Number.isFinite(match.durationMs) ? match.durationMs : null;
  }

  return {
    isRecordedFromStart,
    isUnfinished,
    // У незавершенной партии окончания нет — в истории она датирована стартом
    historyDate: match.finishedAt || match.startedAt || null,
    durationMs,
    lastRecordedRound,
    finalRound: Number.isInteger(match.finalRound) && match.finalRound > 0 ? match.finalRound : null,
  };
};
